import { HeadingH4Atom, LabelAtom, SmallAtom, SpacerAtom } from "../../atoms";
import { TooltipMolecule } from "../tooltip";
import styles from "./styles.module.scss";

interface Props {
  id?: string;
  for?: string;
  label: string;
  tooltip?: string | string[];
  required?: boolean;
}

export function LabelMolecule(props: Readonly<Props>) {
  const label = () => {
    if (!props.label) return null;
    if (props.label && props.for)
      return (
        <LabelAtom id={props.id ?? props.label} type="form" for={props.for} bold>
          {props.label}
        </LabelAtom>
      );
    else
      return (
        <>
          <SpacerAtom space={2} type="horizontal" />
          <HeadingH4Atom id={props.id}>{props.label}</HeadingH4Atom>
          <SpacerAtom space={2} type="horizontal" />
        </>
      );
  };

  return (
    <div className={styles.container}>
      {label()}
      {props.tooltip && <TooltipMolecule id={props.id + "_tooltip"} content={props.tooltip} />}
      {props.required && (
        <>
          <div className={styles.required}></div>
          <SmallAtom text="verplicht veld" />
        </>
      )}
    </div>
  );
}
